import { render } from "./SideBar.vue?vue&type=template&id=fb055d52"
const script = {}

import "./SideBar.vue?vue&type=style&index=0&id=fb055d52&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__